<script lang="ts">
	import type { SbButton } from '$lib/storyblok/types';
	import ButtonBase from '../components/buttons/buttonBase.svelte';
	import Overlay from '../components/overlay.svelte';
	import { getSbUrl } from '$lib/utils/storyblok/url';
	import { shoppingCart } from '$lib/state/shoppingCart.svelte';
	import type { ISbStoryData } from '@storyblok/js';
	import { editable } from '../editable';
	import Blok from '../blok.svelte';
	import { device } from '$lib/state/device.svelte';

	interface Props {
		content: ISbStoryData<SbButton>['content'];
		onclick?: () => void;
	}

	let { content, onclick }: Props = $props();

	let overlay = $state<{ show: () => void }>();

	let buttonAction = $derived(
		onclick
			? onclick
			: () => {
					if (content.opens_cart) {
						shoppingCart.open();
					} else if (content.opens_overlay) {
						overlay?.show();
					}
				}
	);
</script>

<div
	use:editable={content}
	class={{
		'flex justify-center': content.alignment === 'center',
		'flex justify-end': content.alignment === 'right'
	}}
>
	<ButtonBase
		color={content.color}
		variant={content.variant}
		href={onclick || content.opens_cart || content.opens_overlay
			? undefined
			: getSbUrl(content.link)}
		size={device.data.isDesktop ? content.desktop_size : content.mobile_size}
		onclick={buttonAction}
		title={content.title}
	>
		<span
			class="flex items-center gap-x-[6px] text-center"
			class:flex-row-reverse={content.icon_position === 'before'}
		>
			{content.label}

			{#if content.icon.filename}
				<img
					loading="lazy"
					class="inline h-6 w-6"
					src={content.icon.filename}
					alt={content.icon.alt ?? ''}
					title={content.icon.title ?? ''}
					height={24}
					width={24}
				/>
			{/if}
		</span>
	</ButtonBase>
</div>

{#if content.opens_overlay}
	<Overlay padding={false} bind:this={overlay}>
		{#each content.overlay_blocks || [] as block}
			<Blok content={block} />
		{/each}
	</Overlay>
{/if}
